import { render, staticRenderFns } from "./PerformanceReviewSubmitEditor.vue?vue&type=template&id=0a03a084&"
import script from "./PerformanceReviewSubmitEditor.vue?vue&type=script&lang=js&"
export * from "./PerformanceReviewSubmitEditor.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReviewSubmitEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports